<template>
  <div>
    <quick-link v-for="link in quickLinks"
                :label="link.label"
                :route="link.url"
                :icon="link.icon"
    />
  </div>
</template>

<script>
import QuickLink from '@/components/Dashboard/QuickLink';

export default {
  name: "PropertyQuicklinks",
  components: {
    QuickLink,
  },
  computed: {
    quickLinks() {
      if (this.$can(this.$perm.PROPERTIES_VIEW_PROPERTIES, this.$perm.PERMISSION_TYPE_PROPERTIES)) {
        return [{
          label: 'Stocklist',
          url: 'properties',
          icon: 'propertymanagement',
        }];
      }

      return [{
        label: 'Action List',
        url: 'actions',
        icon: 'clientactions',
      }];

    },
  },
}
</script>

<style scoped>

</style>
